import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { ProductInstance } from "../utils/productClass";

export const useCategoryById = (categoryId: number, refetch = false) => {
  const { subCategories, categories, isLoading } = useSelector((state: any) => state.product);

  const subCategoriesByCategoryId = useMemo(
    () => subCategories.filter((subCategory: any) => subCategory.categoryId === categoryId),
    [subCategories, categoryId],
  );

  useEffect(() => {
    if (!categoryId) return;
    if (refetch || (!subCategoriesByCategoryId?.length && !isLoading)) {
      ProductInstance.getProductSubCategories(categoryId);
    }
  }, [categoryId, refetch]);

  const category = useMemo(
    () => categories.find((category: any) => category.id === categoryId),
    [categories, categoryId],
  );

  return {
    category,
    subCategories: subCategoriesByCategoryId,
  };
};
